import { ScribbleDrawingDTO } from 'business/models/Models';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { EDrawingType } from 'components/plateviewer/well/Well';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { IStyle } from 'Styles';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import WellService from 'business/services/WellService';
import { ButtonsListContainer } from 'components/Button';
import { GlobalPreferencesService } from 'business/services/GlobalPreferencesService';
import { setDrawingFontsPreferences, updateDrawing } from 'redux/reducers/wellReducer';
import {
  AnnotationDrawing,
  DrawingType,
  SelectedDrawingDetails,
} from 'components/well/drawingManager/constants';
import { updateDrawingThunk } from 'redux/thunks/well';

/**
 * This component needs to be refactored
 */

export interface AnnotationPreference {
  fontFamily: string;
  fontSize: number;
}

const createSizeComboArray = () => {
  let i = 2;
  let j = 1;
  const fontSize: number[] = [];
  while (i <= 144) {
    fontSize.push(i);
    i = i + j;
    if (i === 20 || i === 40 || i === 80) {
      j = j + j;
    }
  }
  return fontSize;
};

const fontSizeArray: number[] = createSizeComboArray();
const DEFAULT_FONT_FAMILY = 'Microsoft Sans Serif'; // as per v3
const DEFAULT_FONT_SIZE = 8; // as per v3

interface Props {
  selectedDrawing: SelectedDrawingDetails;
}

const AnnotationTools = (props: Props) => {
  const { selectedDrawing } = props;
  const dispatch = useRMDispatch();
  const [currentAnnotation, setCurrentAnnotation] = useState<AnnotationDrawing>(null);
  const [isBold, setIsBold] = useState<boolean>(false);
  const [isItalic, setIsItalic] = useState<boolean>(false);
  const [isUnderline, setIsUnderline] = useState<boolean>(false);
  const [isLineThrough, setisLineThrough] = useState<boolean>(false);
  const [isAnnotationUpdated, setIsAnnotationUpdated] = useState<boolean>(false);
  const [selectedFontSize, setSelectedFontSize] = useState<number>(2);
  const [fontFamily, setFontFamily] = useState(null);
  const [selectedFont, setSelectedFont] = useState(null);
  const isExpanded = (selectedDrawing?.drawing as AnnotationDrawing)?.expanded;
  useEffect(() => {
    if (!fontFamily) {
      getFontFamiliesCombo();
    }
  }, [selectedDrawing]);

  const getFontSizeCombo = useMemo(() => {
    const optionsCombo = [];
    fontSizeArray.forEach((element) => {
      optionsCombo.push({
        name: element.toString(),
        id: element,
        value: element,
      });
    });
    return optionsCombo;
  }, []);

  const getFontFamiliesCombo = async () => {
    const optionsCombo = [];
    const fonts = await new WellService().getSystemFonts();
    fonts.forEach((element) => {
      optionsCombo.push({
        name: element,
        id: element,
        value: element,
      });
    });
    setFontFamily(optionsCombo);
  };
  useEffect(() => {
    if (selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation) {
      if (selectedDrawing) {
        if (selectedDrawing?.drawing) {
          setCurrentAnnotation(selectedDrawing?.drawing as AnnotationDrawing);
        }
      }
    } else if (selectedDrawing === null) {
      setCurrentAnnotation(null);
    }
  }, [selectedDrawing?.drawingId]);

  useEffect(() => {
    if (currentAnnotation && selectedDrawing) {
      currentAnnotation.fontStyle?.includes('bold') ? setIsBold(true) : setIsBold(false);
      currentAnnotation.fontStyle?.includes('italic')
        ? setIsItalic(true)
        : setIsItalic(false);
      currentAnnotation.textDecoration?.includes('underline')
        ? setIsUnderline(true)
        : setIsUnderline(false);
      currentAnnotation.textDecoration?.includes('line-through')
        ? setisLineThrough(true)
        : setisLineThrough(false);
      setSelectedFontSize(Number(currentAnnotation.size));
      setSelectedFont(currentAnnotation.fontFamily);
      /* eslint-disable */
      const {
        id,
        bgColor,
        color,
        expanded,
        height,
        width,
        x,
        y,
        text,
        ...annotationFontsDetails
      } = currentAnnotation;
      /* eslint-enable */
      dispatch(
        updateDrawing({
          id: selectedDrawing.drawingId,
          drawingType: selectedDrawing.drawingType,
          plateId: selectedDrawing.plateId,
          wellNumber: selectedDrawing.wellNumber,
          dropNumber: selectedDrawing.dropNumber,
          regionName: selectedDrawing.regionName,
          drawingUpdateDetails: annotationFontsDetails,
        }),
      );
    }
  }, [currentAnnotation]);

  useEffect(() => {
    const gpService = new GlobalPreferencesService();
    const fetchAnnotationPreferences = async () => {
      const fontPreference: any = await gpService.getUserProperty(
        'Imaging.PlateViewer.AnnotationDefaultFont',
      );
      if (fontPreference) {
        const fontArray = fontPreference.value.split(',');
        const fontFamilyString = fontArray.length
          ? fontArray[0] === ''
            ? DEFAULT_FONT_FAMILY
            : fontArray[0]
          : DEFAULT_FONT_FAMILY;
        const fontSize =
          fontArray.length > 1
            ? parseInt(fontArray[1].replace(/\D/g, ''))
            : DEFAULT_FONT_SIZE;
        dispatch(
          setDrawingFontsPreferences({
            fontFamily: fontFamilyString,
            fontSize: fontSize,
          }),
        );
        if (!currentAnnotation) {
          setSelectedFont(fontFamilyString);
          setSelectedFontSize(fontSize);
        }
      }
    };
    fetchAnnotationPreferences();
  }, []);

  useEffect(() => {
    if (isAnnotationUpdated && selectedDrawing) {
      if (!selectedDrawing?.drawing) {
        return;
      }
      const updatedAnnotation = selectedDrawing?.drawing as AnnotationDrawing;
      const fontFamilySize =
        updatedAnnotation.fontFamily + ',' + updatedAnnotation.size + 'pt';
      let fontStyle = updatedAnnotation.fontStyle
        ? updatedAnnotation.fontStyle.replace(' ', ',')
        : '';
      fontStyle =
        fontStyle +
        (updatedAnnotation.textDecoration
          ? ',' + updatedAnnotation.textDecoration.replace(' ', ',')
          : '');
      const body = new ScribbleDrawingDTO();
      body.id = selectedDrawing?.drawingId;
      body.fontStyle = fontFamilySize + (fontStyle ? ',style=' + fontStyle : '');
      body.drawingType = EDrawingType.Annotation;
      body.xOffSet = updatedAnnotation.x;
      body.yOffSet = updatedAnnotation.y;
      setIsAnnotationUpdated(false);
    }
  }, [selectedDrawing?.drawing]);

  const styleData = (style: string) => {
    if (currentAnnotation) {
      let fontStyle: string = '';
      if (currentAnnotation.fontStyle?.includes(style)) {
        fontStyle = currentAnnotation.fontStyle.replace(style, '');
        style === 'bold' ? setIsBold(false) : setIsItalic(false);
      } else {
        fontStyle = !currentAnnotation.fontStyle
          ? style
          : currentAnnotation.fontStyle + ' ' + style;
        style === 'bold' ? setIsBold(true) : setIsItalic(true);
      }
      setCurrentAnnotation((prevState) => ({ ...prevState, fontStyle: fontStyle }));
      setIsAnnotationUpdated(true);
    }
  };

  const decorateText = (style: string) => {
    if (currentAnnotation) {
      let textDecoration: string = '';
      if (currentAnnotation.textDecoration?.includes(style)) {
        textDecoration = currentAnnotation.textDecoration.replace(style, '');
        style === 'underline' ? setIsUnderline(false) : setisLineThrough(false);
      } else {
        textDecoration =
          currentAnnotation.textDecoration === ''
            ? style
            : currentAnnotation.textDecoration + ' ' + style;
        style === 'underline' ? setIsUnderline(true) : setisLineThrough(true);
      }
      setCurrentAnnotation((prevState) => ({
        ...prevState,
        textDecoration: textDecoration,
      }));
      setIsAnnotationUpdated(true);
    }
  };

  const onChangeFontSize = useCallback((event) => {
    setSelectedFontSize(event.target.value);
    setCurrentAnnotation((prevState) => ({ ...prevState, size: event.target.value }));
    setIsAnnotationUpdated(true);
  }, []);

  const onChangeFontFamily = useCallback((event) => {
    setSelectedFont(event.target.value);
    setCurrentAnnotation((prevState) => ({
      ...prevState,
      fontFamily: event.target.value,
    }));
    setIsAnnotationUpdated(true);
  }, []);

  const toolButtons: RMCustomButtonProps[] = [
    {
      Icon: (
        <RMSvgIcon id="annotation-annotation-icon" name={'AnnotationIcon'} enableBackground={'true'} fill={'black'} />
      ),
      isDisabled:
        selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
          ? false
          : true,
      onClick: () => {
        dispatch(
          updateDrawingThunk({
            drawingId: selectedDrawing.drawingId,
            drawingType: selectedDrawing.drawingType,
            plateId: selectedDrawing.plateId,
            wellNumber: selectedDrawing.wellNumber,
            dropNumber: selectedDrawing.dropNumber,
            regionName: selectedDrawing.regionName,
            drawingUpdateDetails: { expanded: !isExpanded },
          }),
        );
      },
      customStyle: {
        backgroundColor: isExpanded ? '#ffffff' : '#D3D3D3',
        height: 'fit-content',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#000000',
      },
      iconClass: 'rounded-md p-1',
    },
    {
      Icon: <RMSvgIcon id="annotation-bold-icon"  name={'Bold'} enableBackground={'true'} />,
      isDisabled:
        selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
          ? false
          : true,
      onClick: () => styleData('bold'),
      customStyle: {
        backgroundColor: isBold && selectedDrawing ? '#D3D3D3' : '',
        height: 'fit-content',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#000000',
      },
      iconClass: 'rounded-md p-1',
    },
    {
      Icon: <RMSvgIcon  id="annotation-italic-icon" name={'Italic'} enableBackground={'true'} />,
      isDisabled:
        selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
          ? false
          : true,
      onClick: () => styleData('italic'),
      customStyle: {
        backgroundColor: isItalic && selectedDrawing ? '#D3D3D3' : '',
        height: 'fit-content',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#000000',
      },
      iconClass: 'rounded-md p-1',
    },
    {
      Icon: <RMSvgIcon  id="annotation-underline-icon" name={'Underline'} enableBackground={'true'} />,
      isDisabled:
        selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
          ? false
          : true,
      onClick: () => decorateText('underline'),
      customStyle: {
        backgroundColor: isUnderline && selectedDrawing ? '#D3D3D3' : '',
        height: 'fit-content',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#000000',
      },
      iconClass: 'rounded-md p-1',
    },
    {
      Icon: <RMSvgIcon  id="annotation-linethrough-icon" name={'LineThrough'} enableBackground={'true'} />,
      isDisabled:
        selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
          ? false
          : true,
      onClick: () => decorateText('line-through'),
      customStyle: {
        backgroundColor: isLineThrough && selectedDrawing ? '#D3D3D3' : '',
        height: 'fit-content',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#000000',
      },
      iconClass: 'rounded-md p-1',
    },
  ];
  return (
    <div id="annotationtools-main-container" style={styles.tools}>
      <div id="annotationtools-title" style={styles.toolsHeading}>
        Annotate
      </div>
      <div id="annotationtools-content-wrapper" style={styles.toolsContent}>
        <div
          id="annotationtools-content-select-font"
          style={{ paddingInline: '2%', width: '50%' }}
        >
          <RMSelect
            options={fontFamily}
            selectedValue={selectedFont}
            className="padding5"
            placeholder={'Select Font'}
            disabled={
              selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
                ? false
                : true
            }
            onChange={onChangeFontFamily}
          />
        </div>
        <div
          id="annotationtools-content-font-size"
          style={{ paddingInline: '2%', minWidth: '2%' }}
        >
          <RMSelect
            options={getFontSizeCombo}
            selectedValue={selectedFontSize}
            className="padding5"
            placeholder={'Font Size'}
            disabled={
              selectedDrawing && selectedDrawing?.drawingType === DrawingType.Annotation
                ? false
                : true
            }
            onChange={onChangeFontSize}
          />
        </div>
        <ButtonsListContainer
          containerStyleClass="align-items-center gap-1"
          buttonsList={toolButtons}
        />
      </div>
    </div>
  );
};
const styles: IStyle = {
  tools: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  toolsHeading: {
    paddingBlock: '2%',
    paddingInline: '1%',
    minWidth: 'fit-content',
  },
  toolsContent: {
    display: 'flex',
    paddingBlock: '2%',
    alignItems: 'center',
  },
};
export default AnnotationTools;
